export default "__VITE_ASSET__D3eU6GrD__"